(ns dashboard.components.errors
  (:require [reagent.core :as r]
            [re-frame.core :as rf]
            [dashboard.subs :as subs]
            [dashboard.services.error-reporting :as error-reporting])
  (:require-macros [io.repliance.util.version :refer [get-version-info]]))

(defn error-boundary [& _children]
  (let [error-path   (r/atom nil)
        error        (r/atom nil)
        loader       (r/atom nil)
        on-try-again (fn [_]
                       ;; make loader visible
                       (reset! loader true)
                       ;; Wait for a moment to give the user
                       ;; with the loader to give user some
                       ;; feedback that something is actually happening.
                       ;; If the error is immediately the action might not
                       ;; be visible for the user.
                       (js/setTimeout
                         (fn []
                           (reset! loader false)
                           (reset! error nil))
                         500))]
    (r/create-class
      {:display-name                 "error-boundary"
       :component-did-catch          (fn [_this e info]
                                       (println "reporting react error")
                                       (let [clj-error (js->clj e :keywordize-keys true)]
                                         (rf/dispatch [::error-reporting/report-error {:error-info  (if (instance? js/Error e)
                                                                                                      {:message (.-message e)
                                                                                                       :filename (.-filename e)
                                                                                                       :lineno (.-lineno e)
                                                                                                       :colno (.-colno e)
                                                                                                       :error-name (-> clj-error :error :name)
                                                                                                       :stack (-> clj-error :error :stack)}
                                                                                                      (str e))
                                                                                       :info (when info
                                                                                               (js->clj info))
                                                                                       :user-agent (.-userAgent js/navigator)
                                                                                       :version-info (get-version-info)
                                                                                       :location-href (.-href js/location)}])))
       :get-derived-state-from-error (fn [e]
                                       (reset! error-path (:path @(rf/subscribe [::subs/route])))
                                       (reset! error e) #js {})
       :reagent-render               (fn [& children]
                                       (let [route @(rf/subscribe [::subs/route])]
                                         (if-not @error
                                           ;; If there's no error render the children
                                           (into [:<>] children)
                                           (do
                                             ;; Reset the error if path changes
                                             ;; from the one that was during error
                                             (when-not (= @error-path (:path route))
                                               (reset! error-path nil)
                                               (reset! error nil))

                                             ;; when the loader is set to true show the
                                             ;; loading animation to the user
                                             (if @loader
                                               [:div.section.level.level-items>div.level-item.level-center
                                                (let [loader-size "5rem"]
                                                  [:div.loader.mt-6.animated-logo
                                                   {:style {:border-width "0.5rem"
                                                            :width        loader-size
                                                            :height       loader-size}}])]

                                               ;; In other case render the error boundary view
                                               [:div.container.section
                                                [:h1.title "An error occurred!"]
                                                [:p.align-text-center {:style {:align-content "center"}}
                                                 "Please "
                                                 [:a.mr-1.is-underlined {:on-click on-try-again} "try again"]
                                                 "and if the problem persist try refreshing the page. If refreshing the page do not help, please contact your administrator."]])))))})))

(defn error-container [{:keys [on-delete-error error]}]
  [:div.is-flex
   {:style {:position "fixed"
            :bottom   0
            :left     0
            :width    "100%"
            :height   "100vh" :pointer-events "none"
            :z-index  2250}
    :class ["is-flex-direction-column-reverse" "is-align-items-stretch"]}
   [:nav.is-fixed-bottom>div.notification.is-danger
    {:style {:border-radius 0}}
    [:button.delete.is-rounded {:on-click on-delete-error}]
    (str error)]])
